module.exports = __webpack_public_path__ + "static/gu-b08ac0bd8a86ce725356a6156355fafe.svg";